
import { useApp } from "../../../hooks/useApp"
import { getActiveMaterialByMainProductVariantId, isPos, saveActivePendantsToCookies } from "../../../utils"
import { getPendantProductById, getPendantProductVariantsByMaterial } from "./utils"
import classNames from "classnames"

interface Props {
  className?: string
}

export const Pendants = ({ className }: Props) => {
  const { mainProduct, active, activePendantProductVaraintIds, activePendantProductId, activeMainProductVariantId, setActivePendantProductVaraintIds } = useApp()

  const activeMaterial = getActiveMaterialByMainProductVariantId(mainProduct, activeMainProductVariantId)
  
  const activePendantProduct = getPendantProductById(mainProduct, activePendantProductId)
  const activePendantProductVariantsByMaterial = getPendantProductVariantsByMaterial(activePendantProduct, activeMaterial)
  const availablePendantProductVariantsByMaterial = activePendantProductVariantsByMaterial.filter(variant => variant.available)

  if (availablePendantProductVariantsByMaterial.length === 0) {
    return <p>No available pendant variants.</p>
  }

  return (
    <ul className={classNames(`flex gap-3 xl-max:overflow-x-auto xl:grid xl:grid-cols-6 ${activePendantProduct.title.toLowerCase().includes('letter') ? '2xl:grid-cols-9' : ''} xl:w-fit`, className)}> 
      {availablePendantProductVariantsByMaterial.map((activePendantProductVariant) => {
        const { available } = activePendantProductVariant
        
        if (!activePendantProductVariant.metafields.builderData) {
          console.log(
            '%c' + activePendantProductVariant.title + ' has empty builderData',
            'color: red; font-size: 20px; font-weight: bold; background: yellow; padding: 10px; border: 2px solid red;'
          )
          return
        }

        const handleClick = () => {
          if (active === -1) return

          const nextActivePendantProductVaraintIds = [
            ...activePendantProductVaraintIds.slice(0, active), 
            activePendantProductVariant.id,
            ...activePendantProductVaraintIds.slice(active + 1, activePendantProductVaraintIds.length)
          ]

          setActivePendantProductVaraintIds(nextActivePendantProductVaraintIds)
          isPos() && saveActivePendantsToCookies(mainProduct.id, activeMainProductVariantId, nextActivePendantProductVaraintIds)
        }

        const pendantPreviewTextureUrl = activePendantProductVariant.featuredImageUrl
        const alt = activePendantProductVariant.title

        return (
          <li 
            key={activePendantProductVariant.id} 
            className={classNames(
              "shrink-0 w-[40px] h-[40px] xl:w-[48px] xl:h-[48px] border", 
              activePendantProductVaraintIds[active] === activePendantProductVariant.id 
                ? "border-subdued" 
                : "border-transparent"
          )}>
            <button 
              className={classNames("block w-full h-full", !available && "opacity-30 cursor-not-allowed")}
              onClick={handleClick} 
              disabled={!available}
              title={available ? "" : "This pendant is out of stock."}
            >
              <img 
                className="w-full h-full"
                src={pendantPreviewTextureUrl} 
                alt={alt} 
                width="50"
                height="50"
              />
            </button>
          </li>
        )
      })}
    </ul>
  )
}